import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

interface GetInvoiceCouponsParams {
  invoiceId: string;
}

export interface GetInvoiceCouponsResponse {
  totalDiscount: number;
}

export const getInvoiceCoupons = async ({
  invoiceId,
}: GetInvoiceCouponsParams) => {
  const response = await baseAPI.get<GetInvoiceCouponsResponse>(
    `subscription-invoices/coupons/${invoiceId}`,
  );
  return response.data;
};

export const useGetInvoiceCoupons = (params: GetInvoiceCouponsParams) => {
  return useQuery({
    queryKey: [KEYS.INVOICE_COUPONS, params.invoiceId],
    queryFn: () => getInvoiceCoupons(params),
    enabled: !!params.invoiceId,
  });
};
